import React, { useState } from 'react';
import Sidebar from "../../../Sidebar/Sidebar";
import Header from "../../../Header/Header";
import { FaUniversity, FaUsers, FaAward, FaBullseye } from 'react-icons/fa';

const AboutUs = () => {
  // Sidebar state and toggle
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const teamMembers = [
    {
      id: 1,
      name: "Dr. Sarah Johnson",
      role: "Founder & Director",
      bio: "PhD in Education with 15+ years of experience in academic leadership.",
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Technical Head",
      bio: "Expert in educational technology and platform development.",
    },
    {
      id: 3,
      name: "Priya Patel",
      role: "Student Relations",
      bio: "Dedicated to ensuring exceptional student experiences and support.",
    }
  ];

  const achievements = [
    { icon: <FaUniversity className="text-gray-600 text-2xl md:text-3xl" />, title: "15+ Years", description: "Of educational excellence" },
    { icon: <FaUsers className="text-gray-600 text-2xl md:text-3xl" />, title: "10,000+", description: "Students empowered" },
    { icon: <FaAward className="text-gray-600 text-2xl md:text-3xl" />, title: "25+", description: "National awards won" },
    { icon: <FaBullseye className="text-gray-600 text-2xl md:text-3xl" />, title: "100%", description: "Graduate satisfaction" }
  ];

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 w-full">
      {/* Pass sidebar props */}
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} activePage="/about-us" />
      
      <div className="flex-1 w-0">
        {/* Pass toggleSidebar to Header */}
        <Header toggleSidebar={toggleSidebar} />
        
        <main className="flex-1 p-3 sm:p-4 md:p-6 overflow-auto">
          <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 md:p-8 border border-gray-200">
            
            {/* Hero Section */}
            <section className="text-center mb-8 sm:mb-10 md:mb-12">
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-2 sm:mb-3 md:mb-4">
                About Our Institution
              </h1>
              <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-2">
                Empowering students through innovative education since 2008
              </p>
            </section>

            {/* Mission & Vision */}
            <section className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8 mb-10 sm:mb-12 md:mb-16">
              <div className="bg-gray-50 p-4 sm:p-5 md:p-6 rounded-lg border border-gray-200">
                <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 mb-2 sm:mb-3 md:mb-4 flex items-center">
                  <FaBullseye className="mr-2 text-gray-600 text-sm sm:text-base md:text-xl" /> Our Mission
                </h2>
                <p className="text-sm sm:text-base text-gray-700">
                  To provide transformative educational experiences that prepare students for success in their careers and as engaged global citizens through innovative teaching, cutting-edge research, and meaningful community engagement.
                </p>
              </div>
              <div className="bg-gray-50 p-4 sm:p-5 md:p-6 rounded-lg border border-gray-200">
                <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 mb-2 sm:mb-3 md:mb-4 flex items-center">
                  <FaUniversity className="mr-2 text-gray-600 text-sm sm:text-base md:text-xl" /> Our Vision
                </h2>
                <p className="text-sm sm:text-base text-gray-700">
                  To be recognized as a world-class institution that sets the standard for excellence in education, known for developing leaders who create positive change in their communities and professions.
                </p>
              </div>
            </section>

            {/* History */}
            <section className="mb-10 sm:mb-12 md:mb-16">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-4 sm:mb-5 md:mb-6">
                Our History
              </h2>
              <div className="border-l-4 border-gray-300 pl-4 sm:pl-5 md:pl-6 space-y-4 sm:space-y-6 md:space-y-8">
                <div>
                  <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 mb-1 sm:mb-2">
                    2008 - Foundation
                  </h3>
                  <p className="text-sm sm:text-base text-gray-700">
                    Established with just 50 students and 5 faculty members in a small campus, focusing on quality over quantity.
                  </p>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 mb-1 sm:mb-2">
                    2014 - Expansion
                  </h3>
                  <p className="text-sm sm:text-base text-gray-700">
                    Expanded to offer postgraduate programs and built our state-of-the-art main campus facility.
                  </p>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 mb-1 sm:mb-2">
                    2020 - Digital Transformation
                  </h3>
                  <p className="text-sm sm:text-base text-gray-700">
                    Launched our comprehensive online learning platform, making education accessible worldwide.
                  </p>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 mb-1 sm:mb-2">
                    2023 - Present
                  </h3>
                  <p className="text-sm sm:text-base text-gray-700">
                    Recognized as a leader in innovative education with partnerships across 15 countries.
                  </p>
                </div>
              </div>
            </section>

            {/* Achievements */}
            <section className="mb-10 sm:mb-12 md:mb-16">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-6 sm:mb-7 md:mb-8 text-center">
                Our Achievements
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
                {achievements.map((item, index) => (
                  <div key={index} className="bg-white p-3 sm:p-4 md:p-6 rounded-lg shadow-md border border-gray-200 text-center hover:shadow-lg transition-shadow">
                    <div className="flex justify-center mb-2 sm:mb-3 md:mb-4">{item.icon}</div>
                    <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-1 sm:mb-2">
                      {item.title}
                    </h3>
                    <p className="text-xs sm:text-sm text-gray-600">{item.description}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Team */}
            <section className="mb-8 sm:mb-10 md:mb-12">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-6 sm:mb-7 md:mb-8 text-center">
                Meet Our Leadership
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-5 md:gap-8">
                {teamMembers.map(member => (
                  <div key={member.id} className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow">
                    <div className="p-4 sm:p-5 md:p-6">
                      <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 mb-1">
                        {member.name}
                      </h3>
                      <p className="text-sm sm:text-base text-gray-600 font-medium mb-2 sm:mb-3">
                        {member.role}
                      </p>
                      <p className="text-xs sm:text-sm text-gray-700">{member.bio}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* Values */}
            <section className="bg-gray-50 rounded-lg p-4 sm:p-6 md:p-8 border border-gray-200">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-4 sm:mb-5 md:mb-6 text-center">
                Our Core Values
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
                <div className="bg-white p-4 sm:p-5 md:p-6 rounded-lg shadow-sm border border-gray-200">
                  <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 mb-2 sm:mb-3">
                    Excellence
                  </h3>
                  <p className="text-xs sm:text-sm text-gray-700">
                    We pursue the highest standards in all aspects of our work, fostering a culture of continuous improvement.
                  </p>
                </div>
                <div className="bg-white p-4 sm:p-5 md:p-6 rounded-lg shadow-sm border border-gray-200">
                  <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 mb-2 sm:mb-3">
                    Innovation
                  </h3>
                  <p className="text-xs sm:text-sm text-gray-700">
                    We embrace creative approaches to solve educational challenges and prepare students for the future.
                  </p>
                </div>
                <div className="bg-white p-4 sm:p-5 md:p-6 rounded-lg shadow-sm border border-gray-200 sm:col-span-2 md:col-span-1">
                  <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 mb-2 sm:mb-3">
                    Community
                  </h3>
                  <p className="text-xs sm:text-sm text-gray-700">
                    We build inclusive, supportive environments where all members can thrive and contribute.
                  </p>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AboutUs;